// client/src/components/layout/Header.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut, Menu } from 'lucide-react';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from 'react-i18next';

const Header = ({ title, onToggleSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle window resize to detect mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Set language based on user role
  useEffect(() => {
    if (user?.role === 'admin') {
      // Force English for admin and bank users
      if (i18n.language !== 'en') {
        i18n.changeLanguage('en');
      }
    }
  }, [user, i18n]);

  // Function to get translated title based on user role
  const getTranslatedTitle = () => {
    if (title) {
      // Se viene passato un titolo specifico, usalo
      return title;
    }

    // Altrimenti, determina il titolo basandosi sul ruolo dell'utente
    switch (user?.role) {
      case 'company':
        return t('portal.companyPortal');
      case 'bank':
        return t('portal.bankPortal');
      case 'admin':
        return 'Admin Portal'; // Admin sempre in inglese
      default:
        return t('portal.companyPortal');
    }
  };

  // Funzioni handler
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Funzione per gestire il toggle della sidebar
  const handleToggleSidebar = () => {
    if (onToggleSidebar) {
      onToggleSidebar();
    } else {
      // Fallback: prova a trovare e cliccare il vecchio toggle
      const oldToggle = document.querySelector('.sidebar-toggle');
      if (oldToggle) {
        oldToggle.click();
      } else {
        // Fallback: toggle manuale della classe
        const sidebar = document.querySelector('.sidebar');
        const body = document.body;
        if (sidebar) {
          sidebar.classList.toggle('expanded');
          body.classList.toggle('sidebar-open');
        }
      }
    }
  };

  return (
    <>
      {/* Header principale */}
      <div className="header">
        {/* Pulsante menu fisso (opzioni) - Solo mobile */}
        {isMobile && (
          <button
            className="mobile-menu-fixed"
            onClick={handleToggleSidebar}
            aria-label="Toggle menu"
          >
            <Menu size={22} />
          </button>
        )}

        {/* Titolo centrato */}
        <h1 style={{ color: isMobile ? 'white' : 'rgb(0,32,96)' }}>{getTranslatedTitle()}</h1>

        {/* Actions per desktop */}
        {!isMobile && (
          <div className="user-actions">
            {/* Selettore di lingua solo se NON è admin */}
            {user?.role !== 'admin' && <LanguageSelector />}

            {/* Desktop User Profile */}
            <div className="user-profile">
              <span>{user?.organization?.name || user?.username || 'Admin'}</span>
              <div className="user-menu">
                <button onClick={handleLogout} className="logout-btn-modern">
                  <LogOut size={16} />
                  Logout
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
